import React, { Component } from 'react'
import { Subscribe } from 'unstated'
import { CSSTransitionGroup } from 'react-transition-group'

import setup from '../../module/setup'
import WorkoutStore from '../../store/WorkoutStore'
import QuestionBankStore from '../../store/QuestionBankStore'
import UserResponseStore from '../../store/UserResponseStore'
import { getCurrentWorkout, getWorkoutProgress } from '../../store/selectors'
import { assessQuestion as assessQuestionAction } from '../../store/actions'

import { getNextQuestionSetForWorkout } from '../../module/utils'

import Header from '../_presentational/Header/Header'
import ProgressDots from '../_presentational/ProgressDots/ProgressDots'
import WorkoutCompletion from '../_presentational/WorkoutCompletion/WorkoutCompletion'
import WorkoutQuestion from '../_presentational/WorkoutQuestion/WorkoutQuestion'

import {
  ProgressDotsContainer,
  WorkoutContainer,
  WorkoutInnerContainer,
  WorkoutQuestionTransitionWrapper,
  WorkoutQuestionTransition,
  AnimateWorkoutCompletion,
} from './Workout-styled'

const transitionEnterTimeout = 800
const transitionLeaveTimeout = 800
const slideAnimationTime = 600
const fadeAnimationTime = 800

class Workout extends Component {
  componentWillMount() {
    const { questionBankId, questions, startWorkout } = this.props
    startWorkout({
      questionBankId,
      questions: getNextQuestionSetForWorkout({
        questions,
        numQuestions: setup.selfAssessment.numberOfQuestions,
      }),
    })
  }

  componentWillUnmount() {
    this.props.exitWorkout()
  }

  onCompletion = () => {
    const { questionBankId, onWorkoutCompleted, goToMyDashboard } = this.props
    onWorkoutCompleted({ questionBankId })
    goToMyDashboard()
  }

  render() {
    const {
      questionBankId,
      questionBankTitle,
      currentWorkout,
      goToNextQuestion,
      revealAnswer,
      assessQuestion,
      currentCounter,
    } = this.props
    const { onCompletion } = this
    const { questionIndex, questions, workoutComplete, displayAnswer } = currentWorkout
    const question = questions[questionIndex]
    const onSelect = ({ boxId }) => {
      assessQuestion({
        questionBankId,
        questionId: question.id,
        boxId,
      })
    }
    if (!question && !workoutComplete) {
      return null
    }
    let progress
    if (workoutComplete) {
      progress = getWorkoutProgress({ workout: currentWorkout })
    }

    // fade subsequent questions in slower than the first question (as they need to slide in to place)
    const fadeInQuestionDuration = questionIndex ? '1.2s' : '0.8s'

    return (
      <WorkoutContainer>
        <Header />
        <ProgressDotsContainer>
          <ProgressDots activeIndex={questionIndex - 1} length={questions.length} />
        </ProgressDotsContainer>

        {workoutComplete && (
          <WorkoutInnerContainer>
            <AnimateWorkoutCompletion>
              <WorkoutCompletion
                title={`${questionBankTitle} workout`}
                counter={currentCounter + 1}
                action={onCompletion}
                actionTitle="Back to Dashboard"
                progress={progress}
                fadeIn
              />
            </AnimateWorkoutCompletion>
          </WorkoutInnerContainer>
        )}
        {!workoutComplete && (
          <WorkoutQuestionTransitionWrapper>
            <CSSTransitionGroup
              transitionName="workout-question-transition"
              transitionEnterTimeout={transitionEnterTimeout}
              transitionLeaveTimeout={transitionLeaveTimeout}
            >
              <WorkoutQuestionTransition
                key={question.id}
                slideAnimationTime={slideAnimationTime}
                fadeAnimationTime={fadeAnimationTime}
              >
                <WorkoutInnerContainer>
                  <WorkoutQuestion
                    title={questionBankTitle}
                    question={question.question}
                    onRevealAnswer={revealAnswer}
                    answer={question.answer}
                    displayAnswer={displayAnswer}
                    onSelect={onSelect}
                    response={question.response}
                    onGoToNextQuestion={goToNextQuestion}
                    fadeInQuestion
                    fadeInQuestionDuration={fadeInQuestionDuration}
                  />
                </WorkoutInnerContainer>
              </WorkoutQuestionTransition>
            </CSSTransitionGroup>
          </WorkoutQuestionTransitionWrapper>
        )}
      </WorkoutContainer>
    )
  }
}

export default props => {
  return (
    <Subscribe to={[WorkoutStore, QuestionBankStore, UserResponseStore]}>
      {(workout, questionBank, userResponse) => {
        const thisQuestionBank = questionBank.state.questionBank[props.questionBankId]
        const questionBankTitle = thisQuestionBank.title
        const questions = thisQuestionBank.questions
        const thisUserResponse = userResponse.state.questionBank[props.questionBankId]
        const currentCounter =
          thisUserResponse && thisUserResponse.progressCounter
            ? thisUserResponse.progressCounter
            : 0
        const assessQuestion = ({ questionBankId, questionId, boxId }) => {
          return assessQuestionAction({
            questionBankId,
            questionId,
            boxId,
            workoutStore: workout,
            userResponseStore: userResponse,
          })
        }
        const currentWorkout = getCurrentWorkout({
          workoutState: workout.state,
        })
        return (
          <Workout
            {...props}
            currentWorkout={currentWorkout}
            currentCounter={currentCounter}
            questionBankTitle={questionBankTitle}
            questions={questions}
            startWorkout={workout.startWorkout}
            exitWorkout={workout.exitWorkout}
            goToNextQuestion={workout.goToNextQuestion}
            revealAnswer={workout.revealAnswer}
            assessQuestion={assessQuestion}
            onWorkoutCompleted={userResponse.workoutCompleted}
          />
        )
      }}
    </Subscribe>
  )
}



// WEBPACK FOOTER //
// ./src/component/Workout/Workout.jsx